import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimoniosSection() {
  return <section id="testimonios" className="py-8 sm:py-14 bg-[#0f172a]" data-id="element-287">
      <div className="max-w-6xl mx-auto px-3 sm:px-6" data-id="element-288">
        <div className="text-center mb-6 sm:mb-10" data-id="element-289">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-white mb-2 sm:mb-3" data-id="element-290">
            Testimonios de docentes
          </h2>
          <p className="text-gray-400 text-xs sm:text-base" data-id="element-291">
            Lo que dicen quienes ya están usando el kit en sus aulas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4" data-id="element-292">
          <div className="bg-[#1e293b] p-4 sm:p-6 rounded-xl border border-gray-700 relative hover:border-gray-500 transition-colors" data-id="element-293">
            <QuoteIcon className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-600 h-5 w-5 sm:h-6 sm:w-6 opacity-50" data-id="element-294" />
            <div className="flex gap-0.5 mb-2 sm:mb-3" data-id="element-295">
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-296" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-297" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-298" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-299" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-300" />
            </div>
            <p className="text-gray-200 text-xs sm:text-sm italic mb-3 sm:mb-4 leading-relaxed" data-id="element-301">
              "Me dio estructura y me organizó todo el año de Lengua. Ahora
              tengo las clases armadas y puedo enfocarme en mis alumnos."
            </p>
            <div className="mt-auto" data-id="element-302">
              <p className="text-white font-bold text-xs sm:text-sm" data-id="element-303">
                María Fernanda López
              </p>
              <p className="text-gray-400 text-[10px] sm:text-xs" data-id="element-304">
                Docente de Lengua y Literatura
              </p>
              <p className="text-gray-500 text-[9px] sm:text-[10px] mt-0.5" data-id="element-305">
                Buenos Aires
              </p>
            </div>
          </div>

          <div className="bg-[#1e293b] p-4 sm:p-6 rounded-xl border border-gray-700 relative hover:border-gray-500 transition-colors" data-id="element-306">
            <QuoteIcon className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-600 h-5 w-5 sm:h-6 sm:w-6 opacity-50" data-id="element-307" />
            <div className="flex gap-0.5 mb-2 sm:mb-3" data-id="element-308">
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-309" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-310" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-311" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-312" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-313" />
            </div>
            <p className="text-gray-200 text-xs sm:text-sm italic mb-3 sm:mb-4 leading-relaxed" data-id="element-314">
              "Empecé el ciclo lectivo con todo listo. Los cuadernillos por año
              son súper prácticos y bien organizados."
            </p>
            <div className="mt-auto" data-id="element-315">
              <p className="text-white font-bold text-xs sm:text-sm" data-id="element-316">
                Carolina Beatriz Ruiz
              </p>
              <p className="text-gray-400 text-[10px] sm:text-xs" data-id="element-317">
                Profesora de Lengua
              </p>
              <p className="text-gray-500 text-[9px] sm:text-[10px] mt-0.5" data-id="element-318">
                Córdoba
              </p>
            </div>
          </div>

          <div className="bg-[#1e293b] p-4 sm:p-6 rounded-xl border border-gray-700 relative hover:border-gray-500 transition-colors" data-id="element-319">
            <QuoteIcon className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-600 h-5 w-5 sm:h-6 sm:w-6 opacity-50" data-id="element-320" />
            <div className="flex gap-0.5 mb-2 sm:mb-3" data-id="element-321">
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-322" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-323" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-324" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-325" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-326" />
            </div>
            <p className="text-gray-200 text-xs sm:text-sm italic mb-3 sm:mb-4 leading-relaxed" data-id="element-327">
              "Es práctico, claro y muy completo. Lo adapté a mi planificación
              provincial sin problemas. Mis alumnos participan mucho más."
            </p>
            <div className="mt-auto" data-id="element-328">
              <p className="text-white font-bold text-xs sm:text-sm" data-id="element-329">
                Luciana Gómez
              </p>
              <p className="text-gray-400 text-[10px] sm:text-xs" data-id="element-330">
                Docente de secundaria
              </p>
              <p className="text-gray-500 text-[9px] sm:text-[10px] mt-0.5" data-id="element-331">
                Rosario
              </p>
            </div>
          </div>

          <div className="bg-[#1e293b] p-4 sm:p-6 rounded-xl border border-gray-700 relative hover:border-gray-500 transition-colors" data-id="element-332">
            <QuoteIcon className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-600 h-5 w-5 sm:h-6 sm:w-6 opacity-50" data-id="element-333" />
            <div className="flex gap-0.5 mb-2 sm:mb-3" data-id="element-334">
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-335" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-336" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-337" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-338" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-339" />
            </div>
            <p className="text-gray-200 text-xs sm:text-sm italic mb-3 sm:mb-4 leading-relaxed" data-id="element-340">
              "Como coordinadora del área, lo compré para todo el equipo de
              Lengua. Nos ahorró semanas de planificación."
            </p>
            <div className="mt-auto" data-id="element-341">
              <p className="text-white font-bold text-xs sm:text-sm" data-id="element-342">
                Paula Martínez
              </p>
              <p className="text-gray-400 text-[10px] sm:text-xs" data-id="element-343">
                Coordinadora de Lengua
              </p>
              <p className="text-gray-500 text-[9px] sm:text-[10px] mt-0.5" data-id="element-344">
                Mendoza
              </p>
            </div>
          </div>

          <div className="bg-[#1e293b] p-4 sm:p-6 rounded-xl border border-gray-700 relative hover:border-gray-500 transition-colors" data-id="element-345">
            <QuoteIcon className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-600 h-5 w-5 sm:h-6 sm:w-6 opacity-50" data-id="element-346" />
            <div className="flex gap-0.5 mb-2 sm:mb-3" data-id="element-347">
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-348" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-349" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-350" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-351" />
              <StarIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-352" />
            </div>
            <p className="text-gray-200 text-xs sm:text-sm italic mb-3 sm:mb-4 leading-relaxed" data-id="element-353">
              "Siendo estudiante de profesorado, este kit me dio una base sólida
              para mis prácticas. Lo recomiendo totalmente."
            </p>
            <div className="mt-auto" data-id="element-354">
              <p className="text-white font-bold text-xs sm:text-sm" data-id="element-355">
                Valentina Sánchez
              </p>
              <p className="text-gray-400 text-[10px] sm:text-xs" data-id="element-356">
                Estudiante de profesorado
              </p>
              <p className="text-gray-500 text-[9px] sm:text-[10px] mt-0.5" data-id="element-357">
                La Plata
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}